'use strict';

import 'angular';


function extractData(url) {
	var match,
		pl     = /\+/g,  // Regex for replacing addition symbol with a space
		search = /([^&=]+)=?([^&]*)/g,
		decode = s => decodeURIComponent(s.replace(pl, ' ')),
		query  = url.split('?', 2)[1]
	var urlParams = {};
	while (match = search.exec(query))
		urlParams[decode(match[1])] = decode(match[2]);
	return urlParams;
}


function applyFilter(originalUrl, filter) {
	var urlBase = originalUrl.split('?')[0];
	var originalData = extractData(originalUrl);
	var filter = angular.merge(originalData, filter);
	delete filter.page;
	var filterArray = [];
	for (var key in filter) {
		if (filter.hasOwnProperty(key)) {
			filterArray.push(key + '=' + filter[key])
		}
	}
	return urlBase + '?' + filterArray.join('&');
}


export default function() {
	'ngInject';

	return {
		require: ['form', '^brgRestQuery'],
		scope: {
			filter: '<',
		},
		link: link,
	};

	function link(scope, element, attrs, ctrls) {
		var form = ctrls[0];
		var $query = ctrls[1];
		var originalUrl;
		element.on('submit', function(e) {
			if (originalUrl === undefined) {
				originalUrl = $query.url;
			}
			var newUrl = applyFilter(originalUrl, scope.filter);
			$query.query(newUrl)
			$query.appliedFilter = angular.copy(scope.filter);
			e.preventDefault();
		});
	}
}
